module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAAATtJREFUWEft18FNw0AQheE/nXAmTdAEOacToB0ogirgnHOqQE/KSlFk452Zh1CksWQpOXj0+Xl2vN5xJ8fuTpw01P2kOtFO1J2Au1736H8n+gScge8iRHVOl3OqVOTRq/gn8AUcCthX4AV4A/R76ohAH4F3YF/ADqRwutmPKSWEX6EVbBqpm4kkOm4+gy0hs1BdF8GWkRXoLNaCrEK3sFrZY1WHFs7SAsv06G2dpTZ4diIdia4tMI2w8Aj6bVQ5El3CWpHORFXreuHov4a5etNyuBK9Xd3qUZ02rAO6NoL0urVhq9CtOWnDVqBbyNGbFmwWOou0YTPQKNKCjUKzyDI2Ah07/OowHz37Zzv8B+B42d1P78xXpr2ejD5pputEErW8YbJFGppNbu26TrQTdSfgrtc92om6E3DX+wGGq1UrI+mHPgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/image/close-icon.png
// module id = 716
// module chunks = 2